// @ts-nocheck
// Greif UI Kit = line-expand-menu
import React from "react";

const ExpandMenuLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12.482 9.182v5.636q0 .391.345.538.345.145.625-.134l2.42-2.42q.34-.344.341-.803 0-.46-.341-.8l-2.42-2.42q-.28-.28-.625-.135-.345.147-.345.538m-7.41 12.021q-.945 0-1.61-.665a2.2 2.2 0 0 1-.665-1.61V5.072q0-.944.665-1.61t1.61-.665h13.856q.945 0 1.61.665t.665 1.61v13.856q0 .944-.665 1.61-.666.665-1.61.665zm2.88-2.275V5.072h-2.88v13.856zm2.275 0h8.701V5.072h-8.7z"
            />
        </svg>
    );
};

export default React.memo(ExpandMenuLine);
